import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { HomeIconSvgComponent } from '../../../../modules/mapfre-design-library/src/lib/svg/home-icon-svg/home-icon-svg.component';
import { CarIconSvgComponent } from '../../../../modules/mapfre-design-library/src/lib/svg/car-icon-svg/car-icon-svg.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { PolicyDetailsService } from './../../../../_services/my-insurance/policy-details.service';
import { Component, OnInit, Input } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { AlertService } from '@mapfre-design-library/src/public_api';

// --- Components | Services | Models --- //
import { AuthenticationService } from '../../../../_services/_iam/authentication-service.service';
import { UserService } from '../../../../_services/user.service';
import { User } from '@models/user';
import { Location } from '@angular/common';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, CarIconSvgComponent, HomeIconSvgComponent, MapfreButtonComponent],
  selector: 'app-policy-belong-to-another-screen',
  templateUrl: './policy-belong-to-another-screen.component.html',
})
export class PolicyBelongToAnotherScreenComponent implements OnInit {
  @Input() userData: User;
  policyDate: string;
  policyDetails: any;
  policyNumber: string;
  user: any;

  constructor(
    private alertService: AlertService,
    private authService: AuthenticationService,
    public router: Router,
    private userService: UserService,
    private location: Location,
    private policyService: PolicyDetailsService,
    private errorRedirectionService: ErrorRedirectionService
  ) {}

  confirmPolicy() {
    if (this.router.url === '/my-insurance/validate-policy-rights') {
      this.policyService
        .addPolicyToEmail(
          this.user.userDetails.email.address,
          this.policyNumber
        )
        .subscribe(
          () => {
            this.alertService.success('Policy added successfully');
            this.router.navigate(['/my-insurance']);
          },
          (err) => {
            if (
              err.status === 400 ||
              err.status === 401 ||
              err.status === 403 ||
              err.status === 404 ||
              err.status === 408
            ) {
              this.alertService.error('Policy is already added');
              this.router.navigate(['/my-insurance']);
            } else {
              this.errorRedirectionService.redirect(err.status);
            }
          }
        );
    } else {
      this.router.navigate(['signup', 'createnewpassword']);
    }
  }

  goBackAPage(): void {
    this.location.back();
  }

  ngOnInit() {
    this.userService.$user.subscribe((user) => {
      this.policyNumber = `${user.policyDetail}`;
      this.user = user;
      this.policyService.getPolicyDetailsByNumber(this.policyNumber).subscribe(
        (details) => {
          this.policyDetails = details;
        },
        (error) => {
          if (error.status) {
            this.errorRedirectionService.redirect(error.status);
          }
        }
      );
    });
  }
}
